import { AfterViewChecked, ChangeDetectorRef, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { FieldDef, ProjectStage } from 'app/core/models/account.types';
import { Pipeline, Project, SaveProjectMode } from 'app/modules/projects/projects.types';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { MatSelectChange } from '@angular/material/select';
import { ProjectsService } from '../../projects.service';

@Component({
  selector: 'project-change-status',
  templateUrl: './project-change-status.component.html',
  styleUrls: ['./project-change-status.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectChangeStatusComponent implements OnInit, AfterViewChecked {
  project = {} as Project;
  projects: Project[];
  pipelines: Pipeline[];
  projectStages: ProjectStage[];
  requiredFields$: Observable<FieldDef[]>;
  stageId = null;
  isLoading = false;
  invalidDeals = new BehaviorSubject([]);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<ProjectChangeStatusComponent>,
    private _projectsService: ProjectsService,
    private _changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    if (this.data.projects) {
      this.projects = [...this.data.projects];
    }

    if (this.data.projects?.length === 1) {
      this.project = this.projects[0];
    }

    this.projectStages = this.data.data.options.project_stages.filter(
      (option) =>
        !option.hidden &&
        (this.data.pipeline.pipeline_type === 'dynamic' ? true : option.pipeline_ids.includes(this.data.pipeline?.id)),
    );
  }

  stageChange(event: MatSelectChange) {
    this.stageId = event.value;
    const stage = this.data.data.options.project_stages.find((x) => x.id == event.value);
    if (stage?.required_fields?.length) {
      this.requiredFields$ = of(stage?.required_fields.split(',').map((field) => this.lookupField(field)));
    } else {
      this.requiredFields$ = of([] as FieldDef[]);
    }

    this.invalidDeals.next(
      this.projects
        .filter((x) => !stage.pipeline_ids.includes(+x.pipeline_id))
        .map((x) => ({ ...x, pipeline_name: this.data.pipelines.find((y) => y.id === +x.pipeline_id)?.name })),
    );
  }

  ngAfterViewChecked(): void {
    this._changeDetectorRef.detectChanges();
  }

  discard(): void {
    this.matDialogRef.close({ updated: false });
  }

  lookupField(name: string): FieldDef {
    return this.data.data.fieldDefs.find((fieldDef) => fieldDef.name == name);
  }

  save(): void {
    this.isLoading = true;
    const stage = this.projectStages.find((s) => s.id === this.stageId);
    let requiredFields = [];

    if (stage && stage.required_fields?.length) {
      //@ts-ignore
      requiredFields = stage.required_fields.split(',').map((field) => ({
        name: field,
        value: this.project[field],
      }));
    }

    const projectsToUpdate = this.projects.map((project) => {
      const updatePayload = {
        id: project.id,
        project_stage_id: this.stageId,
      };

      requiredFields.forEach((field) => {
        updatePayload[field.name] = field.value || project[field.name];
      });

      return updatePayload;
    });

    this._projectsService
      .saveProjects(projectsToUpdate as Project[], SaveProjectMode.ChangeStatus)
      .subscribe(() => this.matDialogRef.close({ updated: true }));
  }
}
